import { type JSONData } from "../base_classes/dto.d";

export class Dimension {
  /// ///////////////////////////////////////
  /// ///////// PUBLIC VARIABLES ////////////
  /// ///////////////////////////////////////
  /**
   * The amount of the dimension.
   */
  amount: number = 0;

  /**
   * The unit type of the dimension.
   */
  unitType: DimensionUnitType = "METER";

  /// //////////////////////////////
  /// ///////// METHODS ////////////
  /// //////////////////////////////

  /**
   * To string
   */
  label(): string {
    return `${this.amount}${unitTypeToLabel[this.unitType] ?? ""}`;
  }

  /**
   * Set the Dimension's properties
   */
  set(data: unknown): void {
    if (typeof data !== "object") {
      return;
    }
    const json = data as JSONData;
    this.amount = parseFloat(json.amount?.toString() ?? "0") ?? 0;
    this.unitType = (json.unitType as DimensionUnitType) ?? "CENTIMETER";
  }

  /**
   * Parse to JSON
   */
  toJSON(): JSONData {
    return {
      amount: this.amount,
      unitType: this.unitType,
    };
  }
}

/**
 * List of unit types for Dimension
 */
export type DimensionUnitType =
  | "CENTIMETER"
  | "METER"
  | "INCH"
  | "FOOT"
  | "GRAM"
  | "KILOGRAM"
  | "POUND";
export const UnitTypeValues: Record<string, DimensionUnitType> = Object.freeze({
  CENTIMETER: "CENTIMETER",
  METER: "METER",
  INCH: "INCH",
  FOOT: "FOOT",
  GRAM: "GRAM",
  KILOGRAM: "KILOGRAM",
  POUND: "POUND",
});

const unitTypeToLabel: Record<DimensionUnitType, string> = {
  CENTIMETER: "cm",
  METER: "m",
  INCH: "in",
  FOOT: "ft",
  GRAM: "g",
  KILOGRAM: "kg",
  POUND: "lb",
};
